import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { map, range } from 'lodash/fp';
import { IconButton } from '@material-ui/core';
import {
  FirstPage, LastPage, ChevronLeft, ChevronRight,
} from '@material-ui/icons';
import { floorByTen, ceilByTen } from '../../utils';

const styles = {
  icon: css`
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  `,
};

const S = {
  IconButton: styled(({ active, ...otherProps }) => <IconButton {...otherProps} />)`
    width: 24px;
    height: 24px;
    padding: 0;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: ${({ theme }) => theme.typography.pxToRem(12)};
    ${({ active, theme }) => active && css`
      color: ${theme.palette.primary.main};
      background-color: ${theme.palette.grey[200]};
      font-weight: 700;
    `}
  `,
  FirstPage: styled(FirstPage)`
    ${styles.icon}
  `,
  LastPage: styled(LastPage)`
    ${styles.icon}
  `,
  ChevronLeft: styled(ChevronLeft)`
    ${styles.icon}
  `,
  ChevronRight: styled(ChevronRight)`
    ${styles.icon}
  `,
};

/**
 * Pagination을 사용하여 페이지를 전환할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
 */

const Pagination = ({ pageCount, pageNumber, onClick }) => (
  <div>
    <S.IconButton
      type="button"
      data-page-number={1}
      onClick={onClick}
    >
      <S.FirstPage />
    </S.IconButton>
    <S.IconButton
      type="button"
      data-page-number={
        floorByTen(pageNumber - 1) > 1
          ? floorByTen(pageNumber - 1) : 1
      }
      onClick={onClick}
    >
      <S.ChevronLeft />
    </S.IconButton>
    {map(num => (
      <S.IconButton
        key={num}
        type="button"
        data-page-number={num + 1}
        active={num + 1 === pageNumber}
        onClick={onClick}
      >
        {num + 1}
      </S.IconButton>
    ), range(
      pageNumber % 10 ? floorByTen(pageNumber) : pageNumber - 10,
      ceilByTen(pageNumber) < pageCount ? ceilByTen(pageNumber) : pageCount,
    ))}
    <S.IconButton
      type="button"
      data-page-number={
        pageCount > ceilByTen(pageNumber)
          ? ceilByTen(pageNumber) + 1 : pageCount
      }
      onClick={onClick}
    >
      <S.ChevronRight />
    </S.IconButton>
    <S.IconButton
      type="button"
      data-page-number={pageCount}
      onClick={onClick}
    >
      <S.LastPage />
    </S.IconButton>
  </div>
);

Pagination.propTypes = {
  /** 총 페이지 수 */
  pageCount: PropTypes.number.isRequired,
  /** 현재 보고있는 페이지 번호 */
  pageNumber: PropTypes.number.isRequired,
  /** 페이지 번호를 클릭했을 때 실행될 콜백 함수 */
  onClick: PropTypes.func.isRequired,
};

export default Pagination;
